<form class="lot-jump" (ngSubmit)="jumpToLot()">
    <label class="lot-jump__label" for="lot-number-jump">
        {{ 'AuctionsPage.jumpToLotLabel' | translate }}
    </label>
    <input
        id="lot-number-jump"
        type="text"
        inputmode="text"
        enterkeyhint="go"
        autocomplete="off"
        class="lot-jump__input"
        name="lotNumberJump"
        [(ngModel)]="lotNumberJump"
        [disabled]="isJumpingToLot"
        [placeholder]="'AuctionsPage.jumpToLotPlaceholder' | translate" />
    <button
        type="submit"
        class="lot-jump__submit"
        aria-label="Jump to lot"
        [disabled]="isJumpingToLot || !lotNumberJump.trim()">
        <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true">
            <polyline points="9 6 15 12 9 18" />
        </svg>
    </button>
</form>
